import { createBrowserRouter } from "react-router-dom";

import App from "@/App";
import NewDesignLayout from "@/components/NewDesign/NewDesignLayout.tsx";
import RedirectNotification from "@/components/RedirectNotification";
import RouteErrorFallback from "@/components/RouteErrorFallback";
import { config, flags } from "@/config";
import AuthSuccess from "@/routes/authSuccess";
import SubPage from "@/routes/workspace/SubPage.tsx";
import DirectAuth from "./directAuth";
import Onboarding from "./onboarding";
import QrLogin from "./qrLogin";
import Root from "./root";
import DebugItemId from "./workspace/debugItem";
import Dispatch from "./workspace/dispatch";
import FeedId from "./workspace/feedId";
import LoadingWorkspace from "./workspace/LoadingWorkspace";
import MaintenanceMode from "./workspace/MaintenanceMode";
import WorkspaceId from "./workspace/workspaceId";

const routes = [
  {
    // Outside the App wrapper on purpose: the page is static and unauthenticated, and mounting it under
    // App's providers would page-track a URL that carries the one-time sign-in token into analytics.
    path: "/qr-login",
    element: <QrLogin />,
    errorElement: <RouteErrorFallback />,
  },
  {
    element: <App config={config} flags={flags} />,
    errorElement: <RouteErrorFallback />,
    children: [
      {
        path: "/",
        element: <Root />,
      },
      {
        path: "/workspaces/:workspaceId/:subPage",
        element: (
          <NewDesignLayout>
            <SubPage />
          </NewDesignLayout>
        ),
      },
      {
        path: "/workspaces",
        element: <NewDesignLayout />,
        children: [
          {
            path: "/workspaces/:workspaceId",
            element: <WorkspaceId />,
          },
          {
            path: "/workspaces/:workspaceId/loading-workspace",
            element: <LoadingWorkspace />,
          },
          {
            path: "/workspaces/:workspaceId/drivers/:workspaceMembershipId/channel/:feedId",
            element: <FeedId type="drivers" />,
          },
          {
            path: "/workspaces/:workspaceId/dispatch",
            element: <Dispatch />,
          },
          {
            // Same param names as the drivers route so CurrentFeedProvider and FeedId resolve the popover's feed.
            path: "/workspaces/:workspaceId/dispatch/:workspaceMembershipId/channel/:feedId",
            element: <Dispatch />,
          },
          {
            // Catch-all for /channels/:feedId plus retired 1.0 /feeds/:feedId links (old
            // bookmarks / notifications), which FeedId rewrites to their 2.0 equivalents.
            path: "/workspaces/:workspaceId/:type/:feedId",
            element: <FeedId type="legacy" />,
          },
          {
            path: "/workspaces/:workspaceId/feeds/:feedId/items/:itemId/debug",
            element: <DebugItemId />,
          },
        ],
      },
      {
        path: "/onboarding",
        element: <Onboarding />,
      },
      {
        path: "/authSuccess",
        element: <AuthSuccess />,
      },
      {
        path: "/notification-redirect",
        element: <RedirectNotification />,
      },
      {
        path: "/directAuth",
        element: <DirectAuth />,
      },
      {
        path: "/maintenance-mode",
        element: <MaintenanceMode />,
      },
    ],
  },
];
export const router: ReturnType<typeof createBrowserRouter> = createBrowserRouter(routes);
